<template>
	<div class="full-height">
		<Header></Header>
		<div class="flex-center">
			<div class="main-container">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="/dtdl">地图导览</a>
					</span>
				</div>

				<div class="flex" style="min-height: 400px;justify-content: center;width: 100%;">
					<div>
						<h1 ref="title" class="dtzp-title">晋冀鲁豫烈士陵园地图导览</h1>
						
						<el-image src="/static/img/ditu/ditu.jpg"></el-image>
						
					</div>

				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../../components/Header';
	import Footer from '../../../components/Footer';
	import api from '../../../http/detail'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				
			}
		},
		methods: {

		},
		created() {
			
		},
		mounted() {
			this.$refs.title.scrollIntoView()
		}
	}
</script>

<style scoped>
	.art-title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		line-height: 21px;
	}

	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.dtzp-title {
		text-align: center;
		font-size: 30px;
		color: #3e3a39;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/detail/ditu/index.vue